import { useEffect, useRef } from "react";
import * as journifyTrackingCarEvents from "../services/trackingCarEvents";

const toNumber = (v, def = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : def;
};

const toString = (v, def = "") => (v === undefined || v === null ? def : String(v));

export default function useTrackCompletesBookingVehicle({
  orderData,
  car,
  currency = "SAR",
  creativeSlot,
}) {
  const firedRef = useRef("");

  useEffect(() => {
    const isSuccess =
      orderData?.Status === "success" ||
      orderData?.ResponsMessage === "Paid" ||
      (orderData?.OrderId && !orderData?.MessageError && !orderData?.ErrorMessage);

    if (!orderData || !isSuccess || !orderData?.OrderId || !car) return;

    const key = `${orderData.OrderId}_${car?.ProductTarget || car?.ProductID || ""}`;
    if (firedRef.current === key) return;
    firedRef.current = key;

    const item = {
      item_id: toString(car?.ProductID ?? car?.ProductTarget, ""),
      item_name: toString(car?.DescriptionEn ?? car["Type English"], ""),

      affiliation: "value",
      coupon: "value",
      discount: 0,
      index: 0,

      item_brand: toString(car["Brand English"], "value"),
      item_category: toString(car["Group English"], "value"),
      item_category2: toString(car?.Model, "value"),
      item_category3: toString(car?.category, "value"),
      item_category4: toString(car?.carGroupID, "value"),
      item_category5: toString(car?.type, "value"),

      item_variant: toString(car?.ColorDescriptionEn, "value"),
      location_id: toString(creativeSlot, "value"),

      price: toNumber(car?.NetSalePrice, 0),
      quantity: 1,
    };

    const total = toNumber(orderData?.Total, item.price);
    const tax = toNumber(orderData?.Tax ?? orderData?.VAT ?? 0, 0);
    const shipping = toNumber(orderData?.Shipping ?? 0, 0);
    const coupon = toString(orderData?.Coupon ?? "", "");

    journifyTrackingCarEvents.trackPurchase(
      orderData.OrderId,
      total,
      tax,
      shipping,
      coupon,
      [item],
      currency
    );
  }, [orderData, car, currency, creativeSlot]);
}
